import styled from 'styled-components';

export const EntradaItensContainer = styled.div`
  padding-right: 12px;
  .bg-green {
    border-radius: 5px;
    background-color: #a0f2a0;
    padding-bottom: 5px;
  }

  .css-64pf72-Field {
    margin-top: 0px;
  }

  .itens-container {
    border-radius: 5px;
    display: grid;
    width: 100%;
    background: #b7ebf0;
    gap: 5px;
    margin: 0;
    padding: 10px;
    grid-template-columns: repeat(7, 1fr);
    @media screen and (max-width: 1200px) {
      grid-template-columns: repeat(3, 1fr);
    }
    @media screen and (max-width: 572px) {
      grid-template-columns: 1fr;
    }
  }
`;
